module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-72x72-63436e044208f5aaa197af3e8510e712.png";